<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  export let maxPage
  export let activePage
  let arr = [2, 3, 4, 5]

  $: changePage(activePage, maxPage)
  const changePage = () => {
    if (activePage <= 4 && activePage <= maxPage - 3) {
      arr = [2, 3, 4, 5]
    }
    if (activePage > 4 && activePage < maxPage - 3) {
      arr = [Number(activePage) - 1, activePage, Number(activePage) + 1]
    }
    if (activePage >= maxPage - 3 && activePage >= 4) {
      arr = [Number(maxPage) - 4, Number(maxPage) - 3, Number(maxPage) - 2, Number(maxPage) - 1]
    }
    // dispatch("pageNo", activePage)
  }
</script>

<div class="flex select-none items-center justify-center">
  <div class="flex gap-1">
    <button
      disabled={activePage == 1}
      on:click={() => {
        activePage--
        // changePage()
        dispatch("pageNo", activePage)
      }}
      class="h-8 w-8 rounded-md p-1 text-blue-600 hover:bg-blue-600 hover:text-white active:bg-blue-400 disabled:cursor-not-allowed dark:text-gray-200 hover:dark:text-white lg:h-10 lg:w-10"
    >
      <i class="fa-solid fa-chevron-left" />
    </button>
    {#if maxPage < 8}
      {#each Array(maxPage) as pagination, i}
        <button
          class="flex h-8 w-8 items-center justify-center rounded-md p-1 text-[13px] font-bold hover:bg-blue-600 hover:text-white active:bg-blue-500 dark:hover:text-white lg:h-10 lg:w-10 {activePage == i + 1 ? 'bg-blue-500 text-white' : ' dark:text-gray-200'}"
          on:click={() => {
            activePage = i + 1
            // In case of isssue comment this line
            dispatch("pageNo", activePage)
          }}
        >
          {i + 1}
        </button>
      {/each}
    {:else}
      <button
        on:click={() => {
          activePage = 1
          arr = [2, 3, 4, 5]
          // In case of isssue comment this line
          dispatch("pageNo", activePage)
        }}
        class="flex h-8 w-8 items-center justify-center rounded-md p-1 text-[13px] font-bold hover:bg-blue-600 hover:text-white active:bg-blue-500 dark:hover:text-white lg:h-10 lg:w-10 {activePage == 1 ? 'bg-blue-500 text-white' : ' dark:text-gray-200'}"
      >
        1
      </button>
      {#if activePage > 4}
        <button class="h-8 w-8 rounded-md p-1 dark:text-gray-200 lg:h-10 lg:w-10"><i class="fa-solid fa-ellipsis" /></button>
      {/if}
      {#each arr as i}
        <button
          class="flex h-8 hover:bg-blue-600 hover:text-white active:bg-blue-500 hover:dark:text-white lg:h-10 {i.toString().length > 3 ? 'px-2' : 'w-8 lg:w-10'} items-center justify-center rounded-md p-1 text-[13px] font-bold {activePage == i ? 'bg-blue-500 text-white ' : 'dark:text-gray-200 '}"
          on:click={() => {
            activePage = i
            // changePage(i)
            dispatch("pageNo", activePage)
          }}
        >
          {i}
        </button>
      {/each}
      {#if activePage < maxPage - 3}
        <button class="h-8 w-8 rounded-md p-1 dark:text-gray-200 lg:h-10 lg:w-10"><i class="fa-solid fa-ellipsis" /></button>
      {/if}
      <button
        on:click={() => {
          activePage = maxPage
          arr = [maxPage - 4, maxPage - 3, maxPage - 2, maxPage - 1]
          // In case of isssue comment this line
          dispatch("pageNo", activePage)
        }}
        class="flex h-8 items-center justify-center rounded-md p-1 hover:bg-blue-600 hover:text-white active:bg-blue-500 hover:dark:text-white lg:h-10 {maxPage.toString().length > 3 ? 'px-2' : 'w-8 lg:w-10'} text-[13px] font-bold {activePage == maxPage ? 'bg-blue-500 text-white' : 'dark:text-gray-200'}"
      >
        {maxPage}
      </button>
    {/if}
    <button
      on:click={() => {
        activePage++
        // changePage()
        dispatch("pageNo", activePage)
      }}
      disabled={activePage == maxPage}
      class="h-8 w-8 rounded-md p-1 text-blue-600 hover:bg-blue-600 hover:text-white active:bg-blue-400 disabled:cursor-not-allowed dark:text-gray-200 hover:dark:text-white lg:h-10 lg:w-10"
    >
      <i class="fa-solid fa-chevron-right" />
    </button>
  </div>
</div>
